<template>
  <div class="plan-list">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :current="page"
    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType!==2">
            <label>业务机构名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>起始月:</label>
            <timeStampDatePicker  type="month" v-model='query.startTime' class="item" :options="beginDateOptions"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>结束月:</label>
            <timeStampDatePicker type="month" v-model='query.endTime' class="item" :options="endDateOptions"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix" ></goodsSearchItem>

            <!-- <label>商品通用名称:</label>
            <goodsSelect  class="item"  v-model="query.goodsBaseIdList"></goodsSelect> -->
          </div>
           <div class="queryItem">
            <label>商品分类:</label>
            <div class="item">
              <TreeSelect v-model.trim="query.categoryIdList" :data="indicationTree" :props="{title: 'label', value: 'value', children: 'children'}"></TreeSelect>
            </div>
         </div>
          <div class="queryItem">
            <label>GSP分类:</label>
            <lk-select v-model='query.labelIdList' class="item" clearable multiple >
              <lk-option v-for="(item,index) in labels" :key="index" :value='item.id'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>是否DTP:</label>
            <lk-select v-model='query.isDtp' class="item" clearable  >
              <lk-option :value='1'>是</lk-option>
              <lk-option :value='2'>否</lk-option>
            </lk-select>
          </div>
           <!-- <div class="queryItem">
            <label>来源:</label>
            <lk-select v-model='query.purchaseType' class="item" clearable  >
              <lk-option v-for='(item ,i) in getGoodsOrigin' :key="i" :value='item.value'>{{item.name}}</lk-option>
            </lk-select>
          </div> -->
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch(false, getTotal)">查询</lk-button>
            <lk-button @click="clear" >重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="report-btns-wrap btn">
          <exportAsync class="mr" @on-click='handleExport' v-if="handlePermission('inventoryTurnoverAnalysisByGoodsExport')"></exportAsync>
          <lk-button type="primary" class="mr" @click='refreshTime'>刷新今日报表</lk-button>
          <div v-if="deadline">数据截止至 {{deadline}}</div>
        </div>


        <div class="Report-total-container">
          <div class="Report-total-title">合计</div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">平均存货额(S):</div>
            <div class="Report-total-item-value">{{total.averageInventoryStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">销售数量:</div>
            <div class="Report-total-item-value">{{total.saleNumStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">累计销售成本(O):</div>
            <div class="Report-total-item-value">{{total.costAmountWithoutTaxStr}}</div>
          </div>
          <!-- <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">不含税毛利率(R):</div>
            <div class="Report-total-item-value">{{total.profitRateWithoutTax}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">周转次数(T=O/S):</div>
            <div class="Report-total-item-value">{{total.turnoverCountStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">交叉比率(R*T):</div>
            <div class="Report-total-item-value">{{total.crossRatio}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">周转天数(P/T):</div>
            <div class="Report-total-item-value">{{total.turnoverDaysStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">年周转次数(365/V):</div>
            <div class="Report-total-item-value">{{total.annualTurnoverStr}}</div>
          </div> -->
        </div>
        <lk-table
          border
          :columns='columns'
          :data='tableData'
          ></lk-table>
      </div>
    </QueryFrame>

  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import exportAsync from '../../components/report/ExportAsync.vue';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import reportService from '../../services/report';
// import goodsSelect from '../../components/report/GoodsSelect.vue';
import reportMixin from './reportMixin.js';
import TreeSelect from '../../components/treeSelect/treeSelect.vue';

export default {
  name: 'inventoryTurnoverAnalysisByGoodsList',
  mixins: [mapState, queryMixins, reportMixin],
  components: {
    QueryFrame, exportAsync, TreeSelect,
  },
  data() {
    return {
      beginDateOptions: {
        disabledDate: (date) => {
          if (date && this.query.endTime) {
            return date.valueOf() > this.query.endTime;// .valueOf();
          }
        },
      },
      endDateOptions: {
        disabledDate: (date) => {
          if (date && this.query.startTime) {
            return date.valueOf() < this.query.startTime;// .valueOf();
          }
        },
      },
      query: {
        startTime: utils.getCurrentMonthTimestamp(),
        endTime: utils.getNextMonthTimestamp(),
        storeIdList: [],
        goodsBaseIdList: [],
      },
      total: {},
      columns: [
        {
          title: '序号',
          minWidth: 60,
          render: (h, { index }) => h('div', index + 1),
        },
        {
          title: '区间',
          key: 'date',
          minWidth: 116,
        },
        {
          title: '跨度(P)',
          key: 'spans',
          minWidth: 116,
        },
        {
          title: '业务机构',
          key: 'goodsStoreVoStoreCode',
          minWidth: 116,
        },
        {
          title: '业务机构名称',
          key: 'goodsStoreVoStoreName',
          minWidth: 116,
        },
        {
          title: '商品编码',
          key: 'goodsStoreVoGoodsSerialCode',
          minWidth: 116,
        },
        {
          title: '商品通用名称',
          key: 'goodsStoreVoGoodsApprovedName',
          minWidth: 116,
        },
        {
          title: '商品规格',
          key: 'goodsStoreVoSpec',
          minWidth: 116,
        },
        {
          title: '商品单位',
          key: 'goodsStoreVoMinPkgUnitName',
          minWidth: 116,
        },
        {
          title: '生产企业',
          key: 'goodsStoreVoProducer',
          minWidth: 116,
        },
        {
          title: '平均存货额(S)',
          key: 'averageInventoryStr',
          minWidth: 116,
        },
        {
          title: '销售数量',
          key: 'saleNumStr',
          minWidth: 116,
        },
        {
          title: '累计销售成本(O)',
          key: 'costAmountWithoutTaxStr',
          minWidth: 116,
        },
        {
          title: '不含税毛利率(R)',
          key: 'profitRateWithoutTax',
          minWidth: 116,
        },
        {
          title: '周转次数(T=O/S)',
          key: 'turnoverCountStr',
          minWidth: 116,
        },
        {
          title: '交叉比率(R*T)',
          key: 'crossRatio',
          minWidth: 116,
        },
        {
          title: '周转天数(V=P/T)',
          key: 'turnoverDaysStr',
          minWidth: 116,
        },
        {
          title: '年周转次数(365/V)',
          key: 'annualTurnoverStr',
          minWidth: 116,
        },
      ],
      tableData: [],
      goodsLoading: false,
      goodsList: [],
    };
  },
  methods: {
    clear() {
      this.query = {
        startTime: utils.getCurrentMonthTimestamp(),
        endTime: utils.getNextMonthTimestamp(),
        storeIdList: [],
        goodsBaseIdList: [],
      };
    },
    handleExport(info, func) {
      this.params.startTime = this.params.startTime && new Date(this.params.startTime).getTime();
      this.params.endTime = this.params.endTime && new Date(this.params.endTime).getTime();
      this.$store.commit('setDisableLoading', true);
      reportService.inventoryTurnoverAnalysisByGoodsExport(utils.deletePageAndSize(this.params))
        .then((res) => {
          if (res.data.status === 200) {
            func(res.data.data);
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getTotal() {
      this.params.startTime = this.params.startTime && new Date(this.params.startTime).getTime();
      this.params.endTime = this.params.endTime && new Date(this.params.endTime).getTime();
      reportService.inventoryTurnoverAnalysisByGoodsTotal(utils.deletePageAndSize(this.params)).then((res) => {
        if (res.data.status === 200) {
          const data = res.data.data;
          if (data.startTime && data.endTime) {
            data.date = `${utils.formatTime(data.startTime, 'YYYY-MM-DD')}至${utils.formatTime(data.endTime, 'YYYY-MM-DD')}`;
          } else {
            data.date = '';
          }
          this.total = data || {};
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        console.log(err);
        utils.handleError(err);
      });
    },

    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      this.params.startTime = this.params.startTime && new Date(this.params.startTime).getTime();
      this.params.endTime = this.params.endTime && new Date(this.params.endTime).getTime();
      if (!this.params.startTime || !this.params.endTime) {
        this.$Message.error('请输入起止月');
        return;
      }

      reportService.inventoryTurnoverAnalysisByGoods(this.params).then((res) => {
        if (res.data.status === 200 && res.data.data.list) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            if (result.startTime && result.endTime) {
              result.date = `${utils.formatTime(result.startTime, 'YYYY-MM-DD')}至${utils.formatTime(result.endTime, 'YYYY-MM-DD')}`;
            } else {
              result.date = '';
            }
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.fetchListIndications();
    this.getLabel();
    this.handleSearch(true, this.getTotal);
    this.getRefreshTime();
  },
};
</script>
<style lang="less" scoped>
.plan-list{
  .query-item{
    display: flex;
    align-items: center;
    .query-label{
      margin-right: 10px;
    }
  }
  .search-btn{
    margin-right: 10px;
  }
  .query-params-wrap{
    padding-bottom: 20px;
  }
  .btn-wrap{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 12px;
    >.ivu-btn{
      margin-right: 16px;
    }
  }
  .btn{
    margin-bottom: 12px
  }
}
</style>
